<template>
  <v-dialog
    :value="visible"
    max-width="45rem"
    persistent
    @input="close"
  >
    <v-card :loading="loading" :disabled="loading">
      <v-card-title>{{ $t('pages.settings.users.addDialog.title') }}</v-card-title>

      <v-divider class="w-100" />

      <validation-observer ref="observer" v-slot="{ invalid }">
        <v-card-text class="pt-5">
          <validation-provider v-slot="{ errors }" name="firstName" rules="required">
            <v-text-field
              v-model="form.firstName"
              class="mb-2"
              outlined
              :error-messages="errors"
              autocomplete="off"
              name="addUserFirstName"
              :label="$t('pages.settings.users.addDialog.firstName')"
            />
          </validation-provider>

          <validation-provider v-slot="{ errors }" name="lastName" rules="required">
            <v-text-field
              v-model="form.lastName"
              class="mb-2"
              outlined
              :error-messages="errors"
              autocomplete="off"
              name="addUserLastName"
              :label="$t('pages.settings.users.addDialog.lastName')"
            />
          </validation-provider>

          <validation-provider v-slot="{ errors }" name="email" rules="required|email">
            <v-text-field
              v-model="form.email"
              class="mb-2"
              type="email"
              outlined
              :error-messages="errors"
              autocomplete="off"
              name="addUserEmail"
              :label="$t('pages.settings.users.addDialog.email')"
            />
          </validation-provider>

          <validation-provider v-slot="{ errors }" name="password" rules="required|min:6">
            <v-text-field
              v-model="form.password"
              outlined
              :error-messages="errors"
              autocomplete="new-password"
              name="addUserPassword"
              :label="$t('pages.settings.users.addDialog.password')"
            />
          </validation-provider>
        </v-card-text>

        <v-divider class="w-100" />

        <v-card-actions class="justify-end">
          <v-btn
            text
            color="error"
            :disabled="loading"
            @click="close"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            :elevation="0"
            :disabled="loading || invalid"
            @click="save"
          >
            {{ $t('pages.settings.users.addDialog.submit') }}
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogAddUser',

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      loading: false,
      form: {
        email: '',
        password: '',
        firstName: '',
        lastName: ''
      }
    }
  },

  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    async save () {
      try {
        this.loading = true
        await this.$http.post('admin/settings/users', this.form)
        this.$notify({ title: this.$t('success'), message: this.$t('pages.settings.users.addDialog.createdSuccess'), type: 'success' })
        this.$emit('finished')
        this.close()
        this.loading = false
      } catch (error) {
        this.loading = false

        if (error.response && error.response.status === 409) {
          this.$notify({ title: this.$t('error'), message: this.$t('pages.settings.users.addDialog.emailTaken'), type: 'error' })

          return
        }

        this.$notify({ title: this.$t('error'), message: this.$t('pages.settings.users.fetchFailed'), type: 'error' })
      }
    },

    close () {
      setTimeout(() => {
        this.resetForm()
      }, 500)

      this.$emit('close')
    },

    resetForm () {
      this.form = {
        email: '',
        password: '',
        firstName: '',
        lastName: ''
      }

      if (this.$refs.observer) {
        this.$refs.observer.reset()
      }
    }
  }
}
</script>
